const TRAINING_PROFILE_CLASS_NAME = 'Profile'

const TRAINING_PROFILE_ROLE = {
  ADMIN: 1,
  TRAINER: 2
}

const TRAINING_PROFILE_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  NAME: 'name',
  ROLE: 'role',
  COUNTRY: 'country',
  TIMEZONE: 'timezone',
  LOCALE: 'locale',
  PLATFORM: 'platform',
  DEVICE_YEAR_CLASS: 'deviceYearClass',
  IP: 'ip',
  BIRTHDAY: 'birthday',
  FITNESS_LEVEL: 'fitnessLevel',
  TRAINING_FREQUENCY: 'trainingFrequency',
  GYM_ACCESS: 'gymAccess',
  BODY_TYPE: 'bodyType',
  BMI: 'bmi',
  BMI_CATEGORY: 'bmiCategory',
  BMR: 'bmr',
  TOTAL_ENERGY_EXPENDITURE: 'totalEnergyExpenditure',
  GENDER: 'gender',
  GOAL: 'goal',
  HEIGHT: 'height',
  HEIGHT_UNIT: 'heightUnit',
  WEIGHT: 'weight',
  WEIGHT_UNIT: 'weightUnit',
  DISTANCE_UNIT: 'distanceUnit',
  LOGGED_WORKOUTS_COUNT: 'loggedWorkoutsCount',
  LOGGED_PLANS_COUNT: 'loggedPlansCount',
  TOTAL_TIME_TRAINED: 'totalTimeTrained',
  AVERAGE_TRAINING_TIME: 'averageTrainingTime',
  EXPO_PUSH_TOKEN: 'expoPushToken',
  STORE_REVIEW_SHOWED_AT: 'storeReviewShowedAt',
  STORE_REVIEWED_AT: 'storeReviewedAt',
  APP_VERSION: 'appVersion',
  WEEKLY_WORKOUTS_COUNT_GOAL: 'weeklyWorkoutsCountGoal',

  // Foreign Keys
  USER_ID: 'userId',

  // Associations
  PREFERENCES: 'preferences',
  WORKOUTS: 'workouts',
  PLANS: 'plans',
  FEEDBACK: 'feedback',
  FEEDBACK_REPLIES: 'feedbackReplies',
  EXERCISE_LOGS: 'exerciseLogs',
  EXERCISE_LOG_SUMMARIES: 'exerciseLogSummaries'
}

export {
  TRAINING_PROFILE_CLASS_NAME,
  TRAINING_PROFILE_ROLE,
  TRAINING_PROFILE_KEY
}
